export default {
    props: {
        disabled: {type: Boolean},
        except: {type: Array, default: () => []},
        referrer: {type: String, default: null},
    },

    computed: {
        canGoBack() {
            return this.except.indexOf('back') === -1;
        },

        canRead() {
            if (this.except.indexOf('read') !== -1) {
                return false;
            }

            if (!this.api.canRead) {
                return false;
            }

            return this.api.canRead(this.model);
        },

        canEdit() {
            if (this.except.indexOf('edit') !== -1) {
                return false;
            }

            if (!this.api.canEdit) {
                return false;
            }

            return this.api.canEdit(this.model);
        },

        canDestroy() {
            if (this.except.indexOf('destroy') !== -1) {
                return false;
            }

            if (!this.api.canDestroy) {
                return false;
            }

            return this.api.canDestroy(this.model);
        },

        canRestore() {
            if (this.except.indexOf('destroy') !== -1) {
                return false;
            }

            if (!this.api.canRestore) {
                return false;
            }

            return this.api.canRestore(this.model);
        },

        showSort() {
            return this.except.indexOf('sort') === -1;
        },

        canMoveDown() {
            if (!this.showSort) {
                return false;
            }

            if (!this.api.canMoveDown) {
                return false;
            }

            return this.api.canMoveDown(this.model);
        },

        canMoveUp() {
            if (!this.showSort) {
                return false;
            }

            if (!this.api.canMoveUp) {
                return false;
            }

            return this.api.canMoveUp(this.model);
        },
    },

    methods: {
        confirmAction(action) {
            const message = this.$t(`${this.notificationsRoot}.notifications.confirm.${action}`, this.confirmLabel);

            return confirm(message);
        },

        handleRead() {
            this.$navigateTo(this.api.show(this.model));
        },

        handleEdit() {
            this.$navigateTo(this.api.edit(this.model));
        },

        handleSuccess(method) {
            if (this.$listeners && this.$listeners[method]) {
                this.$emit(method);
                return;
            }

            if (this.referrer) {
                setTimeout(() => this.$appHistory.goBack(this.referrer), 100);
            } else {
                this.$forceReload(500);
            }
        },

        handleErrors(reason) {
            this.$debugError(reason, this.$options.name, 'handleErrors');

            this.$toastr.error(this.$t('notifications.errors.unknown'));

            if (!reason) {
                this.$toastr.error(this.$t('notifications.errors.unauthorized'));
                this.$navigateTo('/', 500);

                return;
            }

            if (reason && reason.errors && Array.isArray(reason.errors._errors)) {
                reason.errors._errors.forEach((message) => this.$toastr.error(message));
            }

            this.$forceReload(500);
        },

        handleDestroy() {
            if (!this.confirmAction('destroy')) {
                return;
            }

            this.api.destroy(this.model)
                .then(() => this.$toastr.success(this.$t(`${this.notificationsRoot}.notifications.destroyed`)))
                .then(() => this.handleSuccess('destroy'))
                .catch((errors) => this.handleErrors(errors));
        },

        handleRestore() {
            if (!this.confirmAction('restore')) {
                return;
            }

            this.api.restore(this.model)
                .then(() => this.$toastr.success(this.$t(`${this.notificationsRoot}.notifications.restored`)))
                .then(() => this.handleSuccess('restore'))
                .catch((errors) => this.handleErrors(errors));
        },

        handleMoveDown() {
            this.api.moveDown(this.model)
                .then(() => this.$toastr.success(this.$t(`${this.notificationsRoot}.notifications.updated`)))
                .then(() => this.handleSuccess('sort'))
                .catch((errors) => this.handleErrors(errors));
        },

        handleMoveUp() {
            this.api.moveUp(this.model)
                .then(() => this.$toastr.success(this.$t(`${this.notificationsRoot}.notifications.updated`)))
                .then(() => this.handleSuccess('sort'))
                .catch((errors) => this.handleErrors(errors));
        },
    },
};
